const BlogIntroVideo = () => {
  /* !----------------- play video inline  ------------------! */
  const resetVframes = () => {
    const vframes = document.querySelectorAll('.blog-intro--video .video-iframe-container iframe');

    if (!vframes.length) return;

    vframes.forEach(frame => {
      const src = frame.getAttribute('src');
      frame.setAttribute('src', '');
      frame.setAttribute('data-src', src);
    });
  };

  const setVframeSrc = () => {
    const vframes = document.querySelectorAll('.blog-intro--video .video-iframe-container iframe');

    if (!vframes.length) return;

    vframes.forEach(frame => {
      const src = frame.getAttribute('data-src');
      frame.setAttribute('src', src);
    });

    const video = document.querySelector('.blog-intro--video');
    video?.classList.toggle('play');
  };

  // Close button for video post type
  const closeButton = document.querySelectorAll('.blog-intro--video .video-iframe-container .close');

  closeButton.forEach(button => {
    button.addEventListener('click', e => {
      const container = e.currentTarget.closest('.blog-intro--video');
      const iframe = container?.querySelector('.video-iframe-container');
      const video = container?.querySelector('video');

      if (video) {
        video.pause();
      }

      iframe?.classList.toggle('open');
      container?.classList.toggle('play');
      resetVframes();
    });
  });

  const playInline = document.querySelector('#play-inline');

  playInline?.addEventListener('click', e => {
    const container = e.currentTarget.closest('.blog-intro--video');
    const iframe = container?.querySelector('.video-iframe-container');
    const video = container?.querySelector('video');

    if (video) {
      video.play();
    }

    iframe?.classList.add('open');
    setVframeSrc();
  });
};

export default BlogIntroVideo;